import { jsx as x } from "react/jsx-runtime";
import { useContext as T, createContext as w, isValidElement as C, cloneElement as P, createElement as g, Fragment as v } from "react";
import E from "./contact-channels77.js";
const p = w({
  locale: "en-us",
  t: () => ""
}), $ = () => {
  const e = T(p);
  if (!e)
    throw new Error("useTranslations must be used within a TranslationsProvider");
  return e;
}, b = (e, n) => n ? e.replace(/\{\{([^}]+)\}\}/g, (t, s) => {
  const u = n[s.trim()];
  return u !== void 0 ? String(u) : `{{${s}}}`;
}) : e, f = (e, n) => {
  if (!e.includes("<"))
    return e;
  if (!n || !n.length)
    return e.replace(/<(\d+)>(.*?)<\/\1>/gs, "$2");
  const t = [];
  let s = 0;
  const u = /<(\d+)>(.*?)<\/\1>/gs;
  let i;
  for (; (i = u.exec(e)) !== null; ) {
    const [c, o, a] = i, r = parseInt(o, 10);
    if (i.index > s && t.push(e.substring(s, i.index)), n[r]) {
      const l = n[r];
      C(l) ? t.push(P(l, {}, f(a, n))) : typeof l == "function" ? t.push(g(l, {}, f(a, n))) : t.push(a);
    } else
      t.push(a);
    s = i.index + c.length;
  }
  return s < e.length && t.push(e.substring(s)), t.length === 1 ? t[0] : g(v, {}, ...t);
}, j = ({ children: e, locale: n, tenant: t }) => {
  var c, o;
  const s = (o = (c = n || "en-us") == null ? void 0 : c.toLowerCase()) == null ? void 0 : o.replace("-", "_"), u = (a, r) => r.split(".").reduce((l, d) => l ? l[d] : r, a), i = (a, r) => {
    var h, m;
    if (!a)
      return "";
    const l = u((m = (h = E) == null ? void 0 : h[s]) == null ? void 0 : m[t], a) || a, d = b(l, r == null ? void 0 : r.params);
    return r != null && r.components && Array.isArray(r.components) ? f(d, r.components) : d;
  };
  return /* @__PURE__ */ x(p.Provider, { value: { locale: n, t: i }, children: e });
};
export {
  j as TranslationsProvider,
  $ as useTranslations
};
//# sourceMappingURL=contact-channels43.js.map
